import React from 'react';
import './bibliotheque.css';

export default function Bibliotheque() {
    return (
        <section className="text-bibliotheque">
            <div className="container">
                <h1>Bibliotheque</h1>
								<div className="bibli-description">
									<p>
										Les ouvrages et autres sont disponibles pour votre apprentissage et divertissement.
									</p>
									<br />
									<span>
										Aucun document ne doit sortir de la bibliothèque.
										A cause des documents perdus, endommagés ou volés, les livres ne peuvent pas être remplacés.
										Voici quelques conseils d’entretien des livres pour vous aider à conserver les livres de bibliothèque en bon état :
									</span>
									<br />
									<span>
										- Gardez les livres loin de l'eau. Les livres ne fonctionnent pas bien lorsqu’ils sont éclaboussés ou immergés dans l’eau.
									<br />
										- Merci de ne pas exposer les livres à la pluie.
									</span>
									<p>
										- Lavez-vous les mains avant de lire un livre. Des mains propres et sèches aident à prévenir les dommages aux pages.
										Surveillez également ceux des marqueurs, des crayons et des crayons de couleur.
									<br />	
										- Utilisez des signets pour garder votre place dans un livre. Rabattre les coins peut user et déchirer les pages du livre.
									</p>
									<p>
										- Faites attention à la façon dont les livres sont manipulés afin qu'une pression excessive ne soit pas exercée sur le dos du livre. Cela peut entraîner la perte de pages et de sections entières du livre.
									<br />
									<br />
										En cas de soucis, veuillez appeler et parler avec le bibliothécaire. M Kere ou M Djoman.
									</p>
									<br />
									<p>
										Nous faisons tout notre possible pour récupérer les documents endommagés de la bibliothèque avant qu’ils ne soient placés sur les étagères, mais avec autant de livres, de vidéos et de DVD, il n’est pas toujours possible de récupérer les éléments endommagés. S'il vous plaît, aidez-nous en le signalant à notre attention lorsque vous trouvez un tel article. Ensemble, nous pouvons tous contribuer à ce que les documents de la bibliothèque soient agréables à utiliser pour les futurs lecteurs.
									</p>
									<br />
									<span>Mme Denise -Yao A.</span>
									<span>Directrice</span>
								</div>
            </div>
        </section>
    );
}